import { render, staticRenderFns } from "./BlockAdd.vue?vue&type=template&id=7e53c954"
import script from "./BlockAdd.vue?vue&type=script&lang=js"
export * from "./BlockAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports